export const settingsPanelClass = 'md-settings__panel m-0 flex min-w-[200px] flex-col gap-[5px] border border-[#c9cdd6] bg-white p-[7px]'

export const settingsLegendClass = 'p-[5px] text-[#3472a9]'

export const settingsRowClass = 'md-settings__row flex flex-wrap items-center gap-1.5'

export const settingsCheckClass = 'md-settings__check flex cursor-pointer items-center gap-[5px] font-normal [&_input[type=checkbox]]:m-0 [&_input[type=checkbox]]:h-3 [&_input[type=checkbox]]:w-3'

export const settingsRowCheckClass = `${settingsCheckClass} flex-1`

export const settingsFieldClass = 'md-settings__field flex flex-col gap-[3px]'

export const settingsComboClass = 'md-settings__combo text-xs font-[Arial,sans-serif] disabled:cursor-not-allowed disabled:bg-[#eceff3] disabled:text-[#8995a3] disabled:opacity-70'

export const settingsTextInputClass = 'box-border !w-full !rounded-none !border !border-[#a9a9a9] !bg-[#f4f5f6] !p-1 text-xs font-[Arial,sans-serif]'

export type SettingsVariant = 'std' | 'mailbox'

const mailboxClasses = {
  panel: 'm-0 flex w-full max-w-[760px] min-w-0 flex-col gap-4 border-0 bg-white p-0',
  legend: 'mb-3 p-0 text-[20px] font-semibold text-[#17212b]',
  row: 'flex min-h-12 flex-wrap items-center gap-4 border-b border-[#e6ebf0] py-2',
  check: 'flex min-h-9 cursor-pointer items-center gap-3 font-normal text-[#314253] [&_input[type=checkbox]]:m-0 [&_input[type=checkbox]]:h-4 [&_input[type=checkbox]]:w-4 [&_input[type=checkbox]]:accent-[#2563eb]',
  rowCheck: 'flex min-h-9 flex-1 cursor-pointer items-center gap-3 font-normal text-[#314253] [&_input[type=checkbox]]:m-0 [&_input[type=checkbox]]:h-4 [&_input[type=checkbox]]:w-4 [&_input[type=checkbox]]:accent-[#2563eb]',
  field: 'flex flex-col gap-2 border-b border-[#e6ebf0] py-3 text-[#314253]',
  combo: 'h-9 min-w-[160px] rounded border border-[#c8d2dc] bg-white px-2 text-[13px] disabled:cursor-not-allowed disabled:border-[#dbe2e8] disabled:bg-[#f1f5f9] disabled:text-[#94a3b8] disabled:opacity-70',
  textInput: 'box-border !h-9 !w-full !rounded !border !border-[#c8d2dc] !bg-white !px-3 !py-1 text-[13px]',
}

export function settingsClasses(variant: SettingsVariant = 'std') {
  if (variant === 'mailbox') return mailboxClasses
  return {
    panel: settingsPanelClass,
    legend: settingsLegendClass,
    row: settingsRowClass,
    check: settingsCheckClass,
    rowCheck: settingsRowCheckClass,
    field: settingsFieldClass,
    combo: settingsComboClass,
    textInput: settingsTextInputClass,
  }
}
